export const translate = {

    methods: {
        t(string) {
            return string;
        }

    }

};